import React, { Dispatch, SetStateAction } from "react"

import { FaLanguage, FaTimes } from "../../../AppReactIcons"
import FAB from "../../FAB"
import ToggleMachine from "../Utils/ToggleMachine"

const TranslationSelectionBtn: React.FC<{
  title: string
  selected?: boolean
  onClick?: () => void
}> = ({ title, selected, onClick }) => {
  return (
    <button
      className={[
        "p-1 w-full",
        selected
          ? "bg-site-green text-white"
          : "hover:bg-gray-200 text-site-blue-dark",
      ].join(" ")}
      onClick={onClick}
    >
      {title}
    </button>
  )
}

const TranslationSelectionDropDown: React.FC<{
  options: string[]
  selectedLanguage?: string
  updateSelectedLanguage: Dispatch<SetStateAction<string | undefined>>
  close: () => void
  isClose: () => boolean
}> = ({
  options,
  close,
  isClose,
  selectedLanguage,
  updateSelectedLanguage,
}) => {
  if (isClose()) return null
  return (
    <div
      className="bg-white py-2 absolute bottom-0 right-0 w-48 border rounded text-center text-sm shadow overflow-hidden"
      style={{ zIndex: 1, marginBottom: "2.2rem" }}
    >
      <div className="w-full bg-gray-300" style={{ height: "1px" }} />
      <TranslationSelectionBtn
        title="English"
        selected={selectedLanguage === undefined}
        onClick={() => {
          updateSelectedLanguage(undefined)
          close()
        }}
      />
      {options!.map((item, index) => (
        <TranslationSelectionBtn
          key={index}
          title={item}
          selected={selectedLanguage === item}
          onClick={() => {
            updateSelectedLanguage(item)
            close()
          }}
        />
      ))}
      <div className="w-full bg-gray-300" style={{ height: "1px" }} />
    </div>
  )
}

const DropdownToggleButton: React.FC<{
  open: () => void
  close: () => void
  isOpen: () => boolean
}> = ({ open, close, isOpen }) => {
  let Element = (
    <FAB
      onClick={open}
      Icon={<FaLanguage />}
      title="Translate"
      bgColor={"bg-site-blue-dark button-bg-site-blue-dark"}
    />
  )
  if (isOpen()) {
    Element = (
      <FAB
        onClick={close}
        Icon={<FaTimes />}
        title="close"
        bgColor={"bg-red-700 hover:bg-red-600"}
      />
    )
  }
  return Element
}

const GlobalTranslationSelection: React.FC<{
  languages: string[] | undefined | null
  selectedLanguage: string | undefined
  updateSelectedLanguage: Dispatch<SetStateAction<string | undefined>>
}> = ({ languages, selectedLanguage, updateSelectedLanguage }) => {
  if (!languages) return null
  if (!languages.length) return null

  return (
    <div className="flex justify-end ">
      <ToggleMachine>
        {(toggle, open, isOpen, close, isClose) => (
          <div className="relative">
            <TranslationSelectionDropDown
              selectedLanguage={selectedLanguage}
              updateSelectedLanguage={updateSelectedLanguage}
              options={languages}
              isClose={isClose}
              close={close}
            />
            <DropdownToggleButton open={open} close={close} isOpen={isOpen} />
          </div>
        )}
      </ToggleMachine>
    </div>
  )
}

export default GlobalTranslationSelection
